import Cookies from "js-cookie";
import { listPoliticsAdapter } from "../../adapters/get-list-politics.adapter";
import { IGetCompletedPoliticResponse } from "../../models/get-completed-politics.model";
import { IPoliticResponse, IPoliticStatusResponse } from "../../models/get-politic.model";
import { ACCESS_TOKEN } from "../../util/constants/APP_RESERVED_NAME";
import { API_HEADER } from "../../util/constants/HEADERS";

interface politicParams {
    page: number;
    size: number;
}

export async function getPolitics(body: politicParams) {
    const user_json = JSON.parse(localStorage.getItem('asg_user') ?? '{}')

    if (user_json) {

        const bodyPolitic = {
            ...body,
            user_id: user_json.id
        }
        return await fetch(`${process.env.REACT_APP_API_URL}politic/getList`, {
            method: 'POST',
            headers: {
                ...API_HEADER,                
                Authorization: `Bearer ${Cookies.get(ACCESS_TOKEN)}`
            },
            body: JSON.stringify(bodyPolitic)
        })
            .then((response) => response.json())
            .then(async (result: IPoliticResponse) => {
                if (result.status) {
                    return {
                        response: listPoliticsAdapter(result)
                    }
                }
            })
            .catch(err => {
                return {
                    response: {
                        data: {
                            total: 0,
                            totalVisited: 0,
                            politics: []
                        }
                    }
                }
            })
    }
}

export async function getPoliticStatus() {
    const user_json = JSON.parse(localStorage.getItem('asg_user') ?? '{}')

    if (user_json?.id) {
        return await fetch(`${process.env.REACT_APP_API_URL}politic/getPoliticStatusData/${user_json.id}`, {
            method: 'GET',
            headers: {
                ...API_HEADER,                
                Authorization: `Bearer ${Cookies.get(ACCESS_TOKEN)}`
            },
        })
            .then((response) => response.json())
            .then(async (result: IPoliticStatusResponse) => {
                if (result.status) {
                    return {
                        response: result
                    }
                }
            })
            .catch(err => {
                return {
                    response: {
                        data: {
                            total: 0,
                            visited: 0,
                        }
                    }
                }
            })
    }
}

export async function getCompletedPolitics() {
        return await fetch(`${process.env.REACT_APP_API_URL}politic/getPoliticCompleteList`, {
            method: 'GET',
            headers: {
                ...API_HEADER,                
                Authorization: `Bearer ${Cookies.get(ACCESS_TOKEN)}`
            },
        })
            .then((response) => response.json())
            .then(async (result: IGetCompletedPoliticResponse) => {
                if (result.status) {
                    return {
                        data: result.data
                    }
                }
            })
}